import { SOCIALS } from './constants';
import * as styles from './styles.css';
import { clsx } from 'clsx';

interface ISocialsProps {
  theme: 'white' | 'black';
}

export const Socials: React.FC<ISocialsProps> = ({ theme }) => {
  const isWhiteTheme = theme === 'white';

  const iconColor = isWhiteTheme ? 'theme-white' : 'brand-navy';

  return (
    <div className={styles['socials']}>
      {SOCIALS.map(({ id, url, Icon }) => (
        <a href={url} target="_blank" key={id} className={clsx(styles['item'], styles[theme])} rel="noreferrer">
          <Icon color={iconColor} />
        </a>
      ))}
    </div>
  );
};
